export type PlayVideoParams = {
  maxRetries?: number;
  delay?: number;
  backoff?: number;
};

export function playVideo(
  video: HTMLVideoElement,
  { maxRetries = 10, delay = 1000, backoff = 1 }: PlayVideoParams = {},
) {
  let nRetries = 0;

  async function playVideoInner() {
    if (!video.paused) return;
    try {
      await video.play();
    } catch (e) {
      console.error(e);
      if (++nRetries >= maxRetries) return;
      delay *= backoff;
      setTimeout(playVideoInner, delay);
    }
  }

  return playVideoInner();
}
